import {FC, useEffect, useRef, useState} from 'react';
import {useYMaps} from '@pbe/react-yandex-maps';
import {UseFormSetValue} from 'react-hook-form';

import {Box, Button, Modal, Stack} from '@mui/material';
import {colors} from '../../../shared/colors';

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  p: 2,
};

interface IHomeAddressMap {
  setValue: UseFormSetValue<any>;
  open: boolean;
  handleClose: () => void;
  defaultGeoPos?: number[];
  defaultHomeAddress?: string;
}

export const HomeAddressMap: FC<IHomeAddressMap> = ({
  setValue,
  open,
  handleClose,
  defaultGeoPos,
  defaultHomeAddress,
}) => {
  const mapRef = useRef(null);
  const [geoPos, setGeoPos] = useState([]);
  const [homeAddress, setHomeAddress] = useState('');
  const ymaps = useYMaps([
    'Map',
    'control.SearchControl',
    'geocode',
    'control.ZoomControl',
    'templateLayoutFactory',
    'GeoObjectCollection',
  ]);

  const saveAddress = () => {
    setValue('geoPos', geoPos, {shouldDirty: true});
    setValue('homeAddress', homeAddress, {shouldDirty: true});
    handleClose();
  };

  useEffect(() => {
    if (!ymaps || !mapRef.current) {
      return;
    }

    const myMap = new ymaps.Map(mapRef.current, {
      center: [55.76, 37.64],
      zoom: 10,
    });

    // Создаем экземпляр класса ymaps.control.SearchControl
    const mySearchControl = new ymaps.control.SearchControl({
      options: {
        noPlacemark: true,
      },
    });
    // Результаты поиска будем помещать в коллекцию.
    const mySearchResults = new ymaps.GeoObjectCollection(undefined, {
      hintContentLayout: ymaps.templateLayoutFactory.createClass('$[properties.name]'),
    });
    myMap.controls.add(mySearchControl);
    myMap.geoObjects.add(mySearchResults);

    if (!!defaultGeoPos && !!defaultHomeAddress) {
      mySearchControl.search(defaultHomeAddress);
    }

    // При клике по найденному объекту метка становится красной.
    mySearchResults.events.add('click', function (e: ymaps.IEvent) {
      e.get('target').options.set('preset', 'islands#redIcon');
    });
    // Выбранный результат помещаем в коллекцию.
    mySearchControl.events
      .add('resultselect', function (e) {
        const index = e.get('index');
        mySearchControl.getResult(index).then(function (res: any) {
          setGeoPos(res.geometry.getBounds()[0]);
          setHomeAddress((mySearchControl.getResponseMetaData() as any).request);

          mySearchResults.add(res);
        });
      })
      .add('submit', function () {
        mySearchResults.removeAll();
      });

    const zoomControl = new ymaps.control.ZoomControl({
      options: {
        size: 'small',
      },
    });
    myMap.controls.add(zoomControl);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ymaps]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Stack direction="column" spacing={1.5}>
          <div
            ref={mapRef}
            style={{width: '700px', height: '600px', border: `1px solid ${colors['border--white--bg']}`}}
          />
          <Stack direction="row" sx={{justifyContent: 'space-between'}}>
            <Button color="error" variant="outlined" onClick={handleClose}>
              Закрыть
            </Button>
            <Button variant="outlined" disabled={!homeAddress} color="success" onClick={saveAddress}>
              Сохранить
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};
